// extracted by css-extract-rspack-plugin
export default {"zone":"QKj29cuxIWcFwfJy"};